export const actions = {
  PAGINA_OK_TEMPLATE_BY_ID_LOAD_REQUESTED: 'PAGINA_OK_TEMPLATE_BY_ID_LOAD_REQUESTED',
  PAGINA_OK_TEMPLATE_BY_ID_LOAD_SUCCEEDED: 'PAGINA_OK_TEMPLATE_BY_ID_LOAD_SUCCEEDED',
  PAGINA_OK_TEMPLATE_BY_ID_LOAD_FILED: 'PAGINA_OK_TEMPLATE_BY_ID_LOAD_FILED',

  PAGINA_OK_TEMPLATE_UPDATE_REQUESTED: 'PAGINA_OK_TEMPLATE_UPDATE_REQUESTED',
  PAGINA_OK_TEMPLATE_UPDATE_SUCCEEDED: 'PAGINA_OK_TEMPLATE_UPDATE_SUCCEEDED',
  PAGINA_OK_TEMPLATE_UPDATE_FILED: 'PAGINA_OK_TEMPLATE_UPDATE_FILED',

  SECCION_TEMPLATE_BY_ID_LOAD_REQUESTED: 'SECCION_TEMPLATE_BY_ID_LOAD_REQUESTED',
  SECCION_TEMPLATE_BY_ID_LOAD_SUCCEEDED: 'SECCION_TEMPLATE_BY_ID_LOAD_SUCCEEDED',
  SECCION_TEMPLATE_BY_ID_LOAD_FILED: 'SECCION_TEMPLATE_BY_ID_LOAD_FILED',

  SECCION_TEMPLATE_UPDATE_REQUESTED: 'SECCION_TEMPLATE_UPDATE_REQUESTED',
  SECCION_TEMPLATE_UPDATE_SUCCEEDED: 'SECCION_TEMPLATE_UPDATE_SUCCEEDED',
  SECCION_TEMPLATE_UPDATE_FILED: 'SECCION_TEMPLATE_UPDATE_FILED',

  SECCION_MENSAJE_WHATSAPP_REQUESTED: 'SECCION_MENSAJE_WHATSAPP_REQUESTED',
  SECCION_MENSAJE_WHATSAPP_SUCCEEDED: 'SECCION_MENSAJE_WHATSAPP_SUCCEEDED',
  SECCION_MENSAJE_WHATSAPP_FAILED: 'SECCION_MENSAJE_WHATSAPP_FAILED',
}

export const onSubmitUpdatePaginaOkTemplateFormAction = (dispatch, formPaginaOkTemplate) => {
  dispatch({
    type: actions.PAGINA_OK_TEMPLATE_UPDATE_REQUESTED,
    payload: formPaginaOkTemplate,
  })
}

export const getPaginaOkTemplateByPaginaOkTemplateId = (dispatch, paginaOkTemplateId) => {
  dispatch({
    type: actions.PAGINA_OK_TEMPLATE_BY_ID_LOAD_REQUESTED,
    payload: paginaOkTemplateId,
  })
}

export const onSubmitUpdateSeccionTemplateFormAction = (dispatch, formSeccionTemplate) => {
  dispatch({
    type: actions.SECCION_TEMPLATE_UPDATE_REQUESTED,
    payload: formSeccionTemplate,
  })
}

export const getSeccionTemplateByPaginaOkTemplateId = (dispatch, seccionTemplateId) => {
  dispatch({
    type: actions.SECCION_TEMPLATE_BY_ID_LOAD_REQUESTED,
    payload: seccionTemplateId,
  })
}

export const getMensajesWhatsapp = dispatch => {
  dispatch({
    type: actions.SECCION_MENSAJE_WHATSAPP_REQUESTED,
    payload: null,
  })
}
